import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/route", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/route/csv", params);
};

const getLookup = () => {
  return restApi.get("/api/route/lookup");
};

const upsert = data => {
  return restApi.post("/api/route/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/route/${ids}`);
};

const routeService = {
  getAll,
  getAllForCSV,
  getLookup,
  upsert,
  remove,
};

export default routeService;